// The tab icon waits for the fragno1 decision, so it never switches from the old icon to the new
// one mid-load. public/index.html holds a placeholder until then.
const LEGACY_ICONS = [{ rel: 'icon', href: 'favicon.png' }];

// Under public/static/ because staging serves only static/ and favicon.png from public/; any
// other path falls back to index.html.
const FRAGNO1_ICONS = [
  { rel: 'icon', type: 'image/svg+xml', href: 'static/fragno1/favicon.svg' },
  // Safari doesn't support SVG favicons.
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '32x32',
    href: 'static/fragno1/favicon-32.png',
  },
  { rel: 'apple-touch-icon', href: 'static/fragno1/apple-touch-icon.png' },
];

export const applyFavicon = (on) => {
  document
    .querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]')
    .forEach((link) => link.remove());

  (on ? FRAGNO1_ICONS : LEGACY_ICONS).forEach(({ href, ...attrs }) => {
    const link = document.createElement('link');
    Object.entries(attrs).forEach(([name, value]) =>
      link.setAttribute(name, value),
    );
    link.setAttribute('href', `${process.env.PUBLIC_URL}/${href}`);
    document.head.appendChild(link);
  });
};
